import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const DEFAULT_CONFIG = {
  edition: "saas",
  app_name: "Mailwave",
  app_logo_url: null,
  support_email: null,
  single_tenant: false,
  license: { status: "not_required", valid: true, in_grace: false, message: null },
  features: {
    stripe_billing: true,
    public_registration: true,
    plan_limits: true,
    license_check: false,
  },
};

const ConfigContext = createContext({ config: DEFAULT_CONFIG, loading: true });

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState(DEFAULT_CONFIG);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/config/public")
      .then((r) => {
        const data = r.data || {};
        setConfig({
          ...DEFAULT_CONFIG,
          ...data,
          features: { ...DEFAULT_CONFIG.features, ...(data.features || {}) },
        });
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <ConfigContext.Provider value={{ config, loading }}>
      {children}
    </ConfigContext.Provider>
  );
}

export const useConfig = () => useContext(ConfigContext);
